import { render } from "./VinList.vue?vue&type=template&id=27972528&scoped=true"
import script from "./VinList.vue?vue&type=script&lang=js"
export * from "./VinList.vue?vue&type=script&lang=js"

import "./VinList.vue?vue&type=style&index=0&id=27972528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27972528"]])

export default __exports__